import { createTheme } from "@mui/material/styles";
import { alpha, Palette } from "@mui/material";

export const themeStandard: Palette = createTheme({
  palette: {
    primary: {
      main: "#000000",
      light: "#E2E2E2",
      dark: "#2E3032",
      contrastText: "#FFFFFF",
    },
    secondary: {
      main: "#A3E0FC",
      light: "#F4FBFF",
      dark: "#006783",
      contrastText: "#003545",
    },
    tertiary: {
      main: "#37EFDE",
      light: "#B3FFF3",
      dark: "#00C0B0",
      contrastText: "#003732",
    },
    text: {
      primary: "#000000",
      secondary: "#41484D",
      disabled: alpha("#000000", 0.38),
    },
    header: {
      main: "#000000",
      contrastText: "#FFFFFF",
    },
    outline: "#70787D",
    divider: "#C0C7CD",
    background: {
      default: "#F8F9FB",
      paper: "#FFFFFF",
    },
    accent: {
      main: "#93A6FF",
      contrastText: "#001354",
    },
    error: {
      main: "#C00000",
      contrastText: "#FFFFFF",
    },
    info: {
      main: "#1E81A1",
      contrastText: "#FFFFFF",
    },
    success: {
      main: "#00C64D",
      contrastText: "#000000",
    },
    warning: {
      main: "#FDD422",
      contrastText: "#000000",
    },
  },
}).palette;
